module.exports = __webpack_public_path__ + "static/img/list-bg-1.62c778d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/list-bg-1.png
// module id = MZJz
// module chunks = 1